export default "__VITE_ASSET__BbAxQTQH__"